import { render, staticRenderFns } from "./KpiLoudou.vue?vue&type=template&id=636d40e6&scoped=true&"
import script from "./KpiLoudou.vue?vue&type=script&lang=js&"
export * from "./KpiLoudou.vue?vue&type=script&lang=js&"
import style0 from "./KpiLoudou.vue?vue&type=style&index=0&id=636d40e6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636d40e6",
  null
  
)

export default component.exports